import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentModule} from 'app/component/component.module';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {TeComponent} from './te.component';

@NgModule({
    imports: [ComponentModule, CommonModule],
    declarations: [TeComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(TeComponent),
            multi: true,
        },
    ],
})
export class TeModule {}
